import { render } from "./CommonAddContentsForm.vue?vue&type=template&id=6d35d525&scoped=true"
import script from "./CommonAddContentsForm.vue?vue&type=script&lang=js"
export * from "./CommonAddContentsForm.vue?vue&type=script&lang=js"

import "./CommonAddContentsForm.vue?vue&type=style&index=0&id=6d35d525&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./CommonAddContentsForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d35d525"]])

export default __exports__